import VueRouter from 'vue-router'

import Beian from '../view/Beian'
import Home from '../view/Home'
import All from '../view/All'
import Mobile from '../view/Mobile'
import Photo from '../view/Photo'

export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Beian',
      component: Beian
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/all',
      name: 'All',
      component: All
    },
    {
      path: '/m',
      name: 'Mobile',
      component: Mobile
    },
    {
      path: '/photo',
      name: 'Photo',
      component: Photo
    },
  ]
})